import { createFileRoute } from "@tanstack/react-router";
import { StayReceiptPage } from "../../../features/stays/pages/stay-receipt-page";

/**
 * A sibling of `/stays/booking/$reference`, not a child of it.
 *
 * Nesting it as `stays/booking/$reference/receipt` would turn the manage route
 * into a layout, and its component renders no `<Outlet />`, so the receipt
 * would simply never appear. A sibling path also keeps the manage page's own
 * URL untouched, which is the one printed in every confirmation email already
 * sent.
 *
 * `receipt` is on the edge-cache denylist in src/server.ts alongside
 * `checkout`, `confirmation` and `booking`. That is not optional: this page
 * renders a named guest and a paid amount, and the default for anything under
 * a locale prefix is to cache it publicly.
 */
export const Route = createFileRoute("/$lang/_layout/stays/receipt/$reference")({
  component: StayReceiptPage,
});
